



































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";

const couponModule = namespace("coupon");

@Component({
  components: {}
})
export default class CouponCancel extends Vue {
  @couponModule.State("couponCancelList") list!: any;
  @couponModule.State("couponCancelPage") pages!: any;
  @couponModule.State("couponCancelPageLoading")
  couponCancelPageLoading!: boolean;

  couponActivityId: string | (string | null)[] = "";
  couponActivityName: string | (string | null)[] = "";
  searchName: string = "";
  couponStatus: string = "10";
  pageNum: number = 1;
  pageSize: number = 10;
  selfStatus: boolean = false;

  loading: boolean = false;
  finished: boolean = true;

  activeCouponIdList: any = [];
  activeCouponIdAllNum: number = 0;

  bottomDialog: boolean = false;
  isRouter: boolean = false;

  @Watch("$route", { immediate: true })
  private changeRouter(route: any) {
    this.$store.commit("coupon/clearCouponCancelList");
  }

  get loadingShow() {
    return this.loading;
  }
  set loadingShow(newVal) {
    this.loading = this.couponCancelPageLoading;
  }
  get couponList() {
    return this.list;
  }
  set couponList(newVal) {}

  mounted() {
    this.couponActivityId = this.$route.query.couponActivityId;
    this.couponActivityName = this.$route.query.couponActivityName;
    this.getData();
  }
  async getData() {
    const { success } = await this.$store.dispatch(
      "coupon/getCouponPutinList",
      {
        businessEntityId: this.$global.tenantId,
        couponName: this.searchName,
        couponStatus: this.couponStatus,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.selfStatus
      }
    );
    if (success) {
      if (success.data.pages == success.data.pageNum) {
        this.finished = true;
      }
      this.loading = false;
    }
  }
  handleSearchChange() {
    this.finished = false;
    this.selfStatus = true;
    this.activeCouponIdList = [];
    this.activeCouponIdAllNum = 0;
    this.getData();
    this.selfStatus = false;
  }
  onLoadList() {
    this.pageNum++;
    this.getData();
  }
  handleCouponAddClick(item: any, index: number) {
    if (!item.couponPutinActived) {
      this.activeCouponIdAllNum =
        this.activeCouponIdAllNum + Number(item.couponQuantity);
      this.activeCouponIdList.push(item);
    } else {
      this.activeCouponIdAllNum =
        this.activeCouponIdAllNum - Number(item.couponQuantity);
      this.renderactiveCouponIdList(item);
    }
    this.$store.dispatch("coupon/getCouponCancelListActive", { item, index });
  }
  handleShowDetailClick(show: boolean = true) {
    if (this.activeCouponIdList.length === 0) {
      Toast("还未选择券");
      console.log(this.$global);
      return;
    }
    this.bottomDialog = show;
  }
  async handleSubmitClick() {
    if (this.activeCouponIdList.length === 0) {
      Toast("还未选择券");
      console.log(this.$global);
      return;
    }
    const couponIdList: any = this.activeCouponIdList.map((item: any) => {
      return item.couponId;
    });
    console.log(couponIdList);
    const params: any = {
      couponIdList,
      couponActivityId: this.couponActivityId,
      couponActivityName: this.couponActivityName,
      couponActivityBusinessEntityId: this.$global.tenantId,
      couponActivityBusinessEntityTypeId: this.$global.tenantType,
      couponActivityBusinessEntityName: this.$global.tenantName
    };
    const { error, success } = await this.$store.dispatch(
      "coupon/launchCouponBatch",
      params
    );

    if (success) {
      this.handleShowDetailClick(false);
      this.$router.push({ path: `/activityManagement` });
    }
  }
  renderactiveCouponIdList(newVal: any) {
    this.activeCouponIdList = this.activeCouponIdList.filter((item: any) => {
      if (item.couponId !== newVal.couponId) {
        return item;
      }
    });
  }
}
